import { CoachingMethodScreen } from '@/components/CoachingMethodScreen';

export default function CoachingMethod() {
  return <CoachingMethodScreen />;
}
